// const CryptoJS = require('crypto-js')
import { AES, enc } from 'crypto-js';

export default function decrypt(string) {
  var bytes  = AES.decrypt(string, '2Ebqdt9cVuyUJz3jAA');
  return bytes.toString(enc.Utf8);
}